export default __webpack_public_path__ + "static/media/ic_search_white.e6357710.svg";